import React from "react";
import { RiCloseFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import {
  FaSearchLocation,
  FaFacebookF,
  FaYoutube,
  FaInstagramSquare,
} from "react-icons/fa";
import { ImPhone } from "react-icons/im";
import logo2 from "../../../Assets/logo2.png";
function Humburger({ isOpen, onChange }) {
  return (
    <div className={`Menu ${isOpen && "open"}`} id="myDIV">
      <span
        className="material-icons btn-close flex items-center md:text-[30px] text-[22px]"
        onClick={() => onChange(false)}
      >
        Close <RiCloseFill size={40} className="ml-2" />
      </span>
      <div className="Menu-items">
        <div className="">
          <Link to="/" className="hover:no-underline">
            <img src={logo2} alt="Logo" className="w-[80px] md:my-10 mt-10" />
          </Link>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 md:gap-5">
          <div className="lg:mx-20 md:mx-20">
            <ul>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link to="/" className="hover:no-underline hover:text-white">
                  Home
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Rooms"
                  className="hover:no-underline hover:text-white"
                >
                  Rooms
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Restaurant"
                  className="hover:no-underline hover:text-white"
                >
                  Restaurant
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Meeting_and_Events"
                  className="hover:no-underline hover:text-white"
                >
                  Conference & Ball room
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Relaxation"
                  className="hover:no-underline hover:text-white"
                >
                  Relaxations
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Gallery"
                  className="hover:no-underline hover:text-white"
                >
                  Gallery
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Recreation"
                  className="hover:no-underline hover:text-white"
                >
                  Recreation
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Facilities"
                  className="hover:no-underline hover:text-white"
                >
                  Facilities
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/SpecialOffers"
                  className="hover:no-underline hover:text-white"
                >
                  Special Offers
                </Link>
              </li>
              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Online_Booking"
                  className="hover:no-underline hover:text-white"
                >
                  Online Booking
                </Link>
              </li>

              <li
                onClick={() => onChange(false)}
                className="md:text-right text-center text-white text-base md:text-[20px] uppercase hover:no-underline transition ease-in-out delay-150 hover:-translate-x-6 hover:scale-110 duration-300 md:mb-2"
              >
                <Link
                  to="/Contact"
                  className="hover:no-underline hover:text-white"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:px-20 px-5 md:mt-0 mt-10">
            <div>
              <p className="flex items-center md:flex-row flex-col md:gap-8 mb-5">
                <FaSearchLocation className="md:text-[35px] text-[#fff]" />
                <span className="md:text-[22px] text-white text-center md:text-left">
                  Uttar-Pelayed, Murgi Bazar - Saitaliya Road, Telihaty,
                  Gazipur-1740, Bangladesh
                </span>
              </p>
              <p className="flex items-center md:gap-8 md:flex-row flex-col text-white">
                <ImPhone className="md:text-[22px] text-white" />
                <span className="md:text-[22px] text-white text-center md:text-left">
                  +8801867 877 677
                </span>
              </p>
              <div className="flex md:flex-row justify-center md:justify-start">
                <div className="mt-8 flex justify-between w-9/12 border-b border-b-gray-200">
                  <p className="text-[22px] text-white font-thin">Join Us</p>
                  <div className="flex gap-3 mb-3">
                    <a
                      href="https://www.facebook.com/MatirMayaEcoResort"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaFacebookF className="text-white text-[22px] hover:cursor-pointer" />
                    </a>

                    <a href="">
                      {" "}
                      <FaYoutube className="text-white text-[22px] hover:cursor-pointer" />
                    </a>
                    <FaInstagramSquare className="text-white text-[22px] hover:cursor-pointer" />
                  </div>
                </div>
              </div>
              <div className="flex md:flex-row justify-center md:justify-start">
                <div className="lg:w-9/12 md:w-full mt-5 ">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3637.017821054689!2d90.44567721446597!3d24.27610807440777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3756717c98da359b%3A0x7b4d67a1e965542c!2sMatir%20Maya%20Eco%20Resort%2C%20Sreepur%2C%20Gazipur!5e0!3m2!1sen!2sbd!4v1672834124265!5m2!1sen!2sbd"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                    title="matir-maya-map"
                    className="w-full  md:h-[30vh]"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Humburger;
